module.exports = __webpack_public_path__ + "img/sec1.be09798c.png";